export default __webpack_public_path__ + "static/media/777en.4a70d297.PNG";